import { FC } from "react";
import { AccountingMigrationExternalSystem } from "@common/types/domains/accounting/accountingMigration";
import { Button } from "@design-system/Button/Button";
import containerStyles from "../../AddClientDrawerStepsContainer.module.scss";
import styles from "../AddClientDrawerSteps.module.scss";
import { SetupStepFooter } from "./SetupStepFooter";

interface UnsupportedSystemViewProps {
    onBack: () => void;
}

export const UnsupportedSystemView: FC<UnsupportedSystemViewProps> = ({
    onBack,
}) => (
    <div className={styles.container}>
        <div className={styles.header}>Coming soon</div>
        <div className={styles.subheader}>
            Migration from this software isn't available yet. We'll let you know
            when it is.
        </div>
        <div className={styles.subheader}>
            Questions? Email <a href="mailto:help@kick.co">help@kick.co</a>.
        </div>

        <div className={containerStyles.footer}>
            <Button variant="primary" type="button" onClick={onBack} size="xl">
                Back
            </Button>
        </div>
    </div>
);

interface OtherSystemViewProps {
    migrationMethod: AccountingMigrationExternalSystem | null;
    onBack: () => void;
    onNext: () => void;
}

export const OtherSystemView: FC<OtherSystemViewProps> = ({
    migrationMethod,
    onBack,
    onNext,
}) => (
    <div className={styles.container}>
        {migrationMethod ===
        AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE_GL_COA ? (
            <>
                <div className={styles.header}>
                    Upload QuickBooks Online reports
                </div>
                <div className={styles.subheader}>
                    Export your Chart of Accounts and general ledger from
                    QuickBooks Online as CSV files.
                </div>
            </>
        ) : (
            <div className={styles.header}>Migrate from {migrationMethod}</div>
        )}
        <div className={styles.subheader}>
            After onboarding, we'll walk you through uploading and mapping your
            Chart of Accounts.
        </div>

        <SetupStepFooter onBack={onBack} onNext={onNext} isNextEnabled />
    </div>
);
